import { Navigate, useLocation } from "react-router-dom";

// Rutas viejas de ulture.co → su página nueva, sin perder ?gclid=…, ?utm_…= ni el #ancla
// (Google Ads, emails y enlaces guardados). replace: "atrás" no vuelve a la redirección.
export default function KeepQueryRedirect({ to }: { to: string }) {
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: to, search, hash }} replace />;
}
